module.exports = __webpack_public_path__ + "static/media/bckLogin.90ab44d5.svg";